import clsx from '@vangst/lib/clsx'
import { HUBSPOT_SUBJECTS } from '@vangst/services/hubspot'
import useViewer from '@vangst/services/oogst/viewer/useViewer'
import Routes from '@vangst/services/routes'
import { useState } from 'react'
import ClickyExplore from '../../components/navigation/ClickyExplore'
import DialogContact from '../job/feedback/DialogContact'

export const Skittles = (props: React.HTMLAttributes<HTMLUListElement>) => {
  const { children, className, ...rest } = props
  return (
    <ul
      className={clsx('contain-c grid', className ?? 'md:grid-cols-3')}
      {...rest}
    >
      {children}
    </ul>
  )
}

export const JobFindSkittle = () => (
  <li className="flow-y-sm mood-green rounded-md p-12">
    <h2 className="heading-xs">Find a job with Vangst</h2>
    <p className="mb-8">
      Join the cannabis industry’s #1 job platform today to start your cannabis
      career journey.
    </p>
    <ClickyExplore className="mt-auto max-w-fit" href={Routes.SIGN_UP}>
      Create a Profile
    </ClickyExplore>
  </li>
)

export const JobHireWithSkittle = () => (
  <li className="flow-y-sm mood-blue-white rounded-md p-12">
    <h2 className="heading-xs">Hire with Vangst</h2>
    <p className="mb-8">
      We make cannabis staffing and hiring easy. Whether you’re looking for
      temporary employees or senior executives, we are here to help.
    </p>
    <ClickyExplore className="mt-auto max-w-fit" href={Routes.SIGN_UP_COMPANY}>
      Register Your Company
    </ClickyExplore>
  </li>
)

export const LearnVangstSkittle = () => (
  <li className="flow-y-sm mood-green-tint rounded-md p-12">
    <h2 className="heading-xs">Learn with Vangst</h2>
    <p className="mb-8">
      The cannabis industry moves fast, stay up to speed with all the training
      you need to succeed in cannabis.
    </p>
    <ClickyExplore className="mt-auto max-w-fit" href={Routes.LEARN}>
      Learn More
    </ClickyExplore>
  </li>
)

export const LearnJobSeekersSkittle = () => (
  <li className="flow-y-sm mood-green-tint rounded-md p-12">
    <h2 className="heading-xs">Learn For Job Seekers</h2>
    <p className="mb-8">
      Take cannabis industry training courses, earn badges, and stand out in the
      cannabis industry.
    </p>
    <span className=" flow-y-sm mt-auto sm:flow-x-md">
      <ClickyExplore className="mt-auto max-w-fit" href={Routes.TRAININGS}>
        Search Courses
      </ClickyExplore>
    </span>
  </li>
)

export const LearnBusinessSkittle = () => {
  const { viewer } = useViewer()
  const [contactFormValue, setContactFormValue] =
    useState<HUBSPOT_SUBJECTS | null>(null)

  return (
    <li className="flow-y-sm mood-blue-white rounded-md p-12">
      <h2 className="heading-xs">Learn For Businesses</h2>
      <p className="mb-8">
        Educate current and future cannabis industry employees on your product
        and service, recommend training courses, and hire the most qualified and
        committed talent.
      </p>
      <span className=" flow-y-sm mt-auto sm:flow-x-md">
        <ClickyExplore
          className="mt-auto max-w-fit"
          href={Routes.SIGN_UP_COMPANY}
        >
          Register Your Business
        </ClickyExplore>
        <ClickyExplore
          onClick={() => setContactFormValue(HUBSPOT_SUBJECTS.COMPANY_SUPPORT)}
        >
          Host A Training
        </ClickyExplore>
      </span>
      {contactFormValue != null && (
        <DialogContact
          email={viewer?.email ?? ''}
          phone={viewer?.phoneNumber ?? ''}
          state={viewer?.location?.state ?? ''}
          firstName={viewer?.firstName ?? ''}
          lastName={viewer?.lastName ?? ''}
          handleCancel={() => setContactFormValue(null)}
          hubspotContactSubject={contactFormValue}
        />
      )}
    </li>
  )
}

export const ResourceBlogSkittle = () => (
  <li className="flow-y-sm mood-orange rounded-md p-12 text-white">
    <h2 className="heading-xs">Blog</h2>
    <p className="mb-8">
      Stay in the Know: Explore cannabis industry insights, stories, events, and
      career tips. Elevate your professional journey with our expert guidance.
    </p>
    <ClickyExplore
      className="mt-auto max-w-fit text-white"
      href={Routes.BLOG_VANGST}
    >
      View Blog
    </ClickyExplore>
  </li>
)

export const ResourceReportSkittle = () => (
  <li className="flow-y-sm mood-green rounded-md p-12 text-white">
    <h2 className="heading-xs">Reports & Guides</h2>
    <p className="mb-8">
      Unlock Industry Insights: Dive into our Reports and Guides for
      comprehensive cannabis knowledge. Stay informed and make informed
      decisions in this ever-evolving field.
    </p>
    <ClickyExplore className="mt-auto max-w-fit" href={Routes.REPORTS}>
      View Reports & Guides
    </ClickyExplore>
  </li>
)

export const ResourceRequirementsSkittle = () => (
  <li className="flow-y-sm mood-blue rounded-md p-12 text-white">
    <h2 className="heading-xs">How to Work in Cannabis</h2>
    <p className="mb-8">
      Politics, budgets, and public support vary widely depending on where you
      live. We've curated a list of how to get licensed and badged to help
      clarify what you need to know to land cannabis jobs about getting hired in
      your state.
    </p>
    <ClickyExplore
      className="mt-auto max-w-fit"
      href={Routes.REPORTS_STATE_REQUIREMENTS}
    >
      Read More
    </ClickyExplore>
  </li>
)

export const ServicePlanVerifiedSkittle = () => (
  <li className="flow-y-sm mood-green rounded-md p-12">
    <h2 className="heading-xs">Verified: $20/month</h2>
    <p className="mb-8">
      For teams that need flexibility. Start reaching out to candidates quickly
      with our starter, pay-per-hire plan.
    </p>
    <ClickyExplore className="mt-auto max-w-fit" href={'#'}>
      Learn More
    </ClickyExplore>
  </li>
)

export const ServicePlanPremiumSkittle = () => (
  <li className="flow-y-sm mood-blue-white rounded-md p-12">
    <h2 className="heading-xs">Premium: $50/month</h2>
    <p className="mb-8">
      For teams that need flexibility. Start reaching out to candidates quickly
      with our starter, pay-per-hire plan.
    </p>
    <ClickyExplore className="mt-auto max-w-fit" href={'#'}>
      Learn More
    </ClickyExplore>
  </li>
)

export const ServicePlanContactSkittle = () => (
  <li className="flow-y-sm mood-green-tint rounded-md p-12">
    <h2 className="heading-xs">Expert: Contact For Price</h2>
    <p className="mb-8">
      For teams that need flexibility. Start reaching out to candidates quickly
      with our starter, pay-per-hire plan.
    </p>
    <ClickyExplore className="mt-auto max-w-fit" href={'#'}>
      Contact Us
    </ClickyExplore>
  </li>
)
